//
//
//
//
//
//
//
//
//

export default {
    name: "no-data-display",
    props:{
        // 无数据时展示的提示信息
        nodatatips:{
        type:String,
        default:''
        }
    }
}



// WEBPACK FOOTER //
// ./src/pccomponents/NoDataDisplay.vue